<template>
  <div class="jo-author">
    <author-item v-for="(item,index) in authorList" :item="item" :key="'author' + index"></author-item>
    <div v-if="executiveeditorList && executiveeditorList.length > 0 && item != ''" class="single-author"
         v-for="item in executiveeditorList">
      <div class="author-name">{{ item }}</div>
      <div class="author-content">
        <p v-if="lang=='zh'"><span>角 色：</span>责任编辑</p>
        <p v-else><span>Role：</span>Executive editor</p>
      </div>
    </div>
    <author-item v-for="(item,index) in editorList" :item="item" :role="{en:'Editor',zh:'本文编辑'}"
                 :key="'editor' + index"></author-item>
    <div v-if="englisheditorList && englisheditorList.length > 0 && item != ''" class="single-author"
         v-for="item in englisheditorList">
      <div class="author-name">{{ item }}</div>
      <div class="author-content">
        <p v-if="lang=='zh'"><span>角 色：</span>英文编辑</p>
        <p v-else><span>Role：</span>English editor</p>
      </div>
    </div>
    <div v-if="ARTICLE.contribgroup.topicaleditor && ARTICLE.contribgroup.topicaleditor.length > 0 && item != ''"
         class="single-author"
         v-for="item in ARTICLE.contribgroup.topicaleditor">
      <div class="author-name">{{ item }}</div>
      <div class="author-content">
        <p v-if="lang=='zh'"><span>角 色：</span>栏目编辑</p>
        <p v-else><span>Role：</span>Topical Editor</p>
      </div>
    </div>
    <div
      v-if="ARTICLE.contribgroup.executiveecmember && ARTICLE.contribgroup.executiveecmember.length > 0 && item != ''"
      class="single-author"
      v-for="item in ARTICLE.contribgroup.executiveecmember">
      <div class="author-name">{{ item }}</div>
      <div class="author-content">
        <p v-if="lang=='zh'"><span>角 色：</span>责任编委</p>
        <p v-else><span>Role：</span>Executive Ecmember</p>
      </div>
    </div>
    <div v-if="ARTICLE.contribgroup.proofreader && ARTICLE.contribgroup.proofreader.length > 0 && item != ''"
         class="single-author"
         v-for="item in ARTICLE.contribgroup.proofreader">
      <div class="author-name">{{ item }}</div>
      <div class="author-content">
        <p v-if="lang=='zh'"><span>角 色：</span>责任校对</p>
        <p v-else><span>Role：</span>Proofreader</p>
      </div>
    </div>
    <div
      v-if="ARTICLE.contribgroup.englishproofreader && ARTICLE.contribgroup.englishproofreader.length > 0 && item != ''"
      class="single-author"
      v-for="item in ARTICLE.contribgroup.englishproofreader">
      <div class="author-name">{{ item }}</div>
      <div class="author-content">
        <p v-if="lang=='zh'"><span>角 色：</span>英文校对</p>
        <p v-else><span>Role：</span>English Proofreader</p>
      </div>
    </div>
    <div v-if="ARTICLE.contribgroup.typesetter && ARTICLE.contribgroup.typesetter.length > 0 && item != ''"
         class="single-author"
         v-for="item in ARTICLE.contribgroup.typesetter">
      <div class="author-name">{{ item }}</div>
      <div class="author-content">
        <p v-if="lang=='zh'"><span>角 色：</span>排版人员</p>
        <p v-else><span>Role：</span>Typesetter</p>
      </div>
    </div>
    <author-item v-for="(item,index) in reviewerList" :item="item" :role="{en:'Reviewer',zh:'校对'}"
                 :key="'reviewer' + index"></author-item>
    <div v-if="ARTICLE.contribgroup.speaker && ARTICLE.contribgroup.speaker.length > 0 && item != ''"
         class="single-author"
         v-for="item in ARTICLE.contribgroup.speaker">
      <div class="author-name">{{ item }}</div>
      <div class="author-content">
        <p v-if="lang=='zh'"><span>角 色：</span>发言人</p>
        <p v-else><span>Role：</span>Speaker</p>
      </div>
    </div>
    <author-item v-for="(item,index) in translatorList" :item="item" :role="{en:'Translator',zh:'翻译'}"
                 :key="'translator' + index"></author-item>
    <author-item v-for="(item,index) in writerList" :item="item" :role="{en:'Writer',zh:'执笔人'}"
                 :key="'writer' + index"></author-item>
    <div v-if="ARTICLE.contribgroup.academicsecretar && ARTICLE.contribgroup.academicsecretar.length > 0 && item != ''"
         class="single-author"
         v-for="item in ARTICLE.contribgroup.academicsecretar">
      <div class="author-name">{{ item }}</div>
      <div class="author-content">
        <p v-if="lang=='zh'"><span>角 色：</span>学术秘书</p>
        <p v-else><span>Role：</span>Academic Secretar</p>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import authorItem from './authorItem.vue'
  export default {
    data() {
      return {
        lang: this.ARTICLE.defaultlang !== '' ? this.ARTICLE.defaultlang : 'zh',
        contribgroup: this.ARTICLE.contribgroup,
        authorList: [],
        editorList: [],
        writerList: [],
        translatorList: [],
        reviewerList: [],
        executiveeditorList: this.ARTICLE.contribgroup.executiveeditor,
        englisheditorList: this.ARTICLE.contribgroup.englisheditor,
      }
    },
    components: {
      authorItem
    },
    mounted() {
      /*this.$bus.on('currentLang', (lang) => {
       this.lang = lang;
       })*/
    },
    created() {
      if (this.contribgroup.correspondent && this.contribgroup.correspondent) {
        let contribList = this.contribgroup.author.concat(this.contribgroup.correspondent);
        this.authorList = this.getList(contribList);
      } else {
        this.authorList = this.getList(this.contribgroup.author);
      }
      if (this.ARTICLE.contribgroup.editor && this.ARTICLE.contribgroup.editor.length > 0) {
        this.editorList = this.getList(this.ARTICLE.contribgroup.editor);
      }
      if (this.ARTICLE.contribgroup.writer && this.ARTICLE.contribgroup.writer.length > 0) {
        this.writerList = this.getList(this.ARTICLE.contribgroup.writer);
      }
      if (this.ARTICLE.contribgroup.translator && this.ARTICLE.contribgroup.translator.length > 0) {
        this.translatorList = this.getList(this.ARTICLE.contribgroup.translator);
      }
      if (this.ARTICLE.contribgroup.reviewer && this.ARTICLE.contribgroup.reviewer.length > 0) {
        this.reviewerList = this.getList(this.ARTICLE.contribgroup.reviewer);
      }
    },
    methods: {
      getList(contribList) {
        let list = [];
        var affList = this.contribgroup.aff //全部机构
        for (var i in contribList) {
          var profile = [] //作者简介/通信作者简介/第一作者简介
          var bio = [] //简介
          var corresp = false //是否是通讯作者
          var isFirstAuthor = false //是否有第一作者简介
          var supervisor = ['', '']
          var phone = ''
          var currentAuthor = contribList[i]
          var name = ''
          var email = ''
          var authorAffIds = [] //机构
          for (var i in currentAuthor.aff) {
            authorAffIds.push(currentAuthor.aff[i].rid)
          }
          var authorAffIntros = [] //作者所属中文机构
          var authorAffIntrosEn = [] //作者所属英文机构

          var noInfo = true //是否有详细信息

          let collab = '';

          if (currentAuthor.name && currentAuthor.name.length <= 1) {
            if (currentAuthor.stringName && currentAuthor.stringName.length > 0) {
              for (let i = 0; i < currentAuthor.stringName.length; i++) {
                if (currentAuthor.stringName[i].lang === this.lang) {
                  name = currentAuthor.stringName[i].surname;
                }
              }
            }
            if (name === '' && currentAuthor.name.length === 1) {
              if (currentAuthor.name[0].givenname && currentAuthor.name[0].namestyle === 'western') {
                name = currentAuthor.name[0].givenname + ' ' + currentAuthor.name[0].surname
              } else if (currentAuthor.name[0].givenname) {
                name = currentAuthor.name[0].surname + (currentAuthor.name[0].lang === 'en' ? ' ' : '') + currentAuthor.name[0].givenname
              }
            }
          } else if (currentAuthor.name && currentAuthor.name.length > 1) {
            for (let a in currentAuthor.name) {
              if (currentAuthor.name[a].lang === this.lang) {
                name = currentAuthor.name[a].surname;
                if (currentAuthor.name[a].givenname && currentAuthor.name[a].namestyle === 'western') {
                  name = currentAuthor.name[a].givenname + ' ' + currentAuthor.name[a].surname
                } else if (currentAuthor.name[a].givenname) {
                  name = name + (currentAuthor.name[a].lang === 'en' || !(/[\u4E00-\u9FA5]/.test(currentAuthor.name[a].givenname + name))
                      ? ' ' : '') + currentAuthor.name[a].givenname
                }
                break
              }
            }
          }
          if (currentAuthor.collab && currentAuthor.collab.length > 0) {
            for (let a in currentAuthor.collab) {
              if (currentAuthor.collab[a].lang === this.lang) {
                collab = currentAuthor.collab[a].name;
              }
            }
            if (collab === '') {
              collab = currentAuthor.collab[0].name;
            }
          }

          for (var i in authorAffIds) {
            for (var j in affList) {
              if (authorAffIds[i] == affList[j].id) {
                noInfo = false;
                if (affList[j].intro[0].lang == "zh") {
                  authorAffIntros.push(affList[j].intro[0]);
                  if (affList[j].intro.length > 1) {
                    authorAffIntrosEn.push(affList[j].intro[1])
                  }
                } else {
                  authorAffIntrosEn.push(affList[j].intro[0])
                  if (affList[j].intro.length > 1) {
                    authorAffIntros.push(affList[j].intro[1])
                  }
                }
              }
            }
          }

          /*作者简介*/
          if (currentAuthor.hasOwnProperty("first") || currentAuthor.role.indexOf('first-author') > -1) {
            isFirstAuthor = true;
            noInfo = false;
            if (currentAuthor.hasOwnProperty("first")) {
              for (var k in currentAuthor.first) {
                if (currentAuthor.first[k].lang == 'zh') {
                  profile[0] = currentAuthor.first[k].text;
                }
                else profile[1] = currentAuthor.first[k].text;
              }
            }
          }
          if (currentAuthor.hasOwnProperty("corresp") || currentAuthor.role.indexOf('corresp') > -1) {
            noInfo = false;
            if ((profile.length < 1 || this.lang == 'zh' && profile[0] === undefined || this.lang == 'en' && profile[1] === undefined)
              && currentAuthor.hasOwnProperty("corresp")) {
              for (var k in currentAuthor.corresp) {
                if (currentAuthor.corresp[k].lang == 'zh') {
                  profile[0] = currentAuthor.corresp[k].text
                } else profile[1] = currentAuthor.corresp[k].text
              }
            }
            corresp = true
          }
          let equal = false;
          if (currentAuthor.role && currentAuthor.role.indexOf('equal') > -1) {
            equal = true;
          }
          if (currentAuthor.hasOwnProperty("note")) {
            if (profile.length < 1 || this.lang == 'zh' && profile[0] === undefined || this.lang == 'en' && profile[1] === undefined) {
              for (var k in currentAuthor.note) {
                if (currentAuthor.note[k].text && currentAuthor.note[k].text !== '') {
                  noInfo = false;
                  if (currentAuthor.note[k].lang == 'zh') {
                    profile[0] = currentAuthor.note[k].text;
                  } else profile[1] = currentAuthor.note[k].text;
                }
              }
            }
          }

          if (currentAuthor.hasOwnProperty("bio")) {
            bio = currentAuthor.bio;
          }
          /*end作者简介*/

          if (currentAuthor.hasOwnProperty("supervisor")) {
            noInfo = false;
            for (let k in currentAuthor.supervisor) {
              if (currentAuthor.supervisor[k].lang === 'zh') {
                supervisor[0] = currentAuthor.supervisor[k].text;
              } else supervisor[1] = currentAuthor.supervisor[k].text;
            }
          }

          if (currentAuthor.hasOwnProperty("phone")) {
            phone = currentAuthor.phone
            noInfo = false;
          }

          if (currentAuthor.hasOwnProperty("email")) {
            email = currentAuthor.email
            noInfo = false;
          }


          list.push({
            name: name,
            aff: authorAffIntros,
            affEn: authorAffIntrosEn,
            phone: phone,
            email: email,
            profile: profile,
            isFirstAuthor: isFirstAuthor,
            corresp: corresp,
            equal: equal,
            bio: bio,
            supervisor: supervisor,
            noInfo: noInfo,
            orcid: currentAuthor.orcid,
            collab: collab,
            deceased : currentAuthor.deceased
          })
        }
        return list;
      },
    }

  }
</script>

<style lang="scss" scoped>
  .jo-author {
    background-color: #fafafa;
    position: relative;
    padding: 10px 20px 0 20px;
    .single-author {
      .author-name {
        margin-top: 12px;
        font-size: 1.8rem;
        margin-bottom: 1rem;
        color: #333;
        letter-spacing: 0.03em;

      }
      .author-content {
        margin: 0 0 40px 20px;
        font-size: 1.3rem;
        p {
          span {
            font-weight: bold;
          }
          span.text {
            font-weight: normal;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/author/author.vue